const data = 
[
    {
        id: 1,
        route: "articles",
        name: "Articles",
        business_name: "Articles",
        wellness_name: "Articles",
        long_name: "Articles",
        short_name: "Articles",
        text: "",
        icon: "/images/sections/img-articles-white-01.svg",
    },
    {
        id: 11,
        route: "replays",
        name: "Live Event Replays",
        business_name: "Live Event Replays",
        wellness_name: "Live Event Replays",
        long_name: <>Expert Interviews, <br/> Webinars & Live Streams</>,
        short_name: "Replays",
        text: "",
        icon: "/images/sections/img-live-event-replays-white-01.svg",
    },
    {
        id: 2,
        route: "videos",
        name: "Video Library",
        business_name: "Video Library",
        wellness_name: "Video Library",
        long_name: "Video Library",
        short_name: "Videos",
        text: "",
        icon: "/images/sections/img-video-library-white-01.svg",
    },
    {
        id: 4,
        route: "file-cabinet",
        name: "Files",
        business_name: "Business Files",
        wellness_name: "Wellness Files",
        long_name: "Files",
        short_name: "Files",
        text: "",
        icon: "/images/sections/img-wellness-files-white-01.svg",
    },
    {
        id: 12,
        route: "recipes",
        name: "Recipes",
        business_name: "Recipes",
        long_name: "Healthy Recipes",
        short_name: "Recipes",
        text: "",
        icon: "/images/sections/img-recipes-white-01.svg",
        bg: "bg-recipe"
    }
]
export default data